import type { ReactNode, RefObject } from "react";
import { Tooltip } from "@foris/avocado-suite";
import { useSessionTableTooltip } from "../../hooks/session-assignation/useSessionTableTooltip";
import styles from "./sessionTableTooltip.module.scss";

interface SessionTableTooltipProps {
  label: ReactNode;
  children: ReactNode;
  disabled?: boolean;
  focusable?: boolean;
  triggerClassName?: string;
}

const SessionTableTooltip = ({
  label,
  children,
  disabled = false,
  focusable = false,
  triggerClassName,
}: SessionTableTooltipProps) => {
  const tooltip = useSessionTableTooltip(disabled);
  const { Portal } = tooltip;

  return (
    <>
      <div
        ref={tooltip.referenceRef as RefObject<HTMLDivElement>}
        className={`${styles.sessionTableTooltip} ${triggerClassName ?? ""}`}
        role="group"
        tabIndex={focusable && !disabled ? 0 : undefined}
        aria-describedby={tooltip.isOpen ? tooltip.tooltipId : undefined}
        onMouseEnter={tooltip.onMouseEnter}
        onMouseLeave={tooltip.onMouseLeave}
        onFocus={tooltip.onFocus}
        onBlur={tooltip.onBlur}
      >
        {children}
      </div>
      <Portal>
        <Tooltip
          visible
          placement="top"
          className={styles.sessionTableTooltip_tooltip}
          label={
            <div id={tooltip.tooltipId} role="tooltip" className={styles.sessionTableTooltip_label}>
              {label}
            </div>
          }
        >
          <span className={styles.sessionTableTooltip_anchor} />
        </Tooltip>
      </Portal>
    </>
  );
};

export default SessionTableTooltip;
